export const initialEntries = [
  {
    id: 5,
    date: '2026-04-21',
    photos: [{ id: 'demo-5a', url: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?q=80&w=800&auto=format&fit=crop', useInTimelapse: true }],
    glowScore: 9,
    tags: ['Glowy', 'Even tone'],
    water: 80,
    routines: { AM: ['Cleanser', 'Vitamin C Serum', 'SPF 50'], PM: ['Oil Cleanser', 'Retinol', 'Moisturizer'] },
    supplements: [{ name: 'Collagen', dose: '10g' }, { name: 'Probiotic', dose: '1 capsule' }],
    treatments: [],
    makeup: { wore: false, products: [], doubleCleansed: false, notes: '' },
    cycle: { periodDay: false, flow: null, symptoms: [] },
    notes: 'Best skin day in weeks — vitamin C is making a real difference!'
  },
  {
    id: 6,
    date: '2026-04-20',
    photos: [{ id: 'demo-6a', url: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?q=80&w=800&auto=format&fit=crop', useInTimelapse: true }],
    glowScore: 7,
    tags: ['Smooth'],
    water: 64,
    routines: { AM: ['Cleanser', 'Niacinamide', 'SPF 50'], PM: ['Oil Cleanser', 'Hyaluronic Acid', 'Moisturizer'] },
    supplements: [{ name: 'Collagen', dose: '10g' }],
    treatments: [],
    makeup: { wore: true, products: ['lipColor', 'mascara'], doubleCleansed: true, notes: 'Light makeup day, double cleansed well.' },
    cycle: { periodDay: false, flow: null, symptoms: [] },
    notes: 'Good routine day, consistent habits paying off.'
  },
  {
    id: 1,
    date: '2026-04-19',
    photos: [{ id: 'demo-1a', url: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?q=80&w=800&auto=format&fit=crop', useInTimelapse: true }],
    glowScore: 9,
    tags: ['Glowy', 'Smooth', 'Even tone'],
    water: 80,
    routines: { AM: ['Cleanser', 'Vitamin C Serum', 'SPF 50'], PM: ['Oil Cleanser', 'Retinol', 'Moisturizer'] },
    supplements: [{ name: 'Collagen', dose: '10g' }, { name: 'Probiotic', dose: '1 capsule' }],
    treatments: [],
    makeup: { wore: false, products: [], doubleCleansed: false, notes: '' },
    cycle: { periodDay: false, flow: null, symptoms: [] },
    notes: 'Skin looked super tight and bright today. The new vitamin C is working!'
  },
  {
    id: 2,
    date: '2026-04-18',
    photos: [{ id: 'demo-2a', url: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?q=80&w=800&auto=format&fit=crop', useInTimelapse: true }],
    glowScore: 6,
    tags: ['Dry', 'Smooth'],
    water: 40,
    routines: { AM: [], PM: ['Oil Cleanser', 'Moisturizer'] },
    supplements: [{ name: 'Collagen', dose: '10g' }],
    treatments: [],
    makeup: { wore: true, products: ['foundation', 'mascara'], doubleCleansed: false, notes: '' },
    cycle: { periodDay: false, flow: null, symptoms: [] },
    notes: 'Forgot AM routine. A bit dry around the cheeks. Low water day.'
  },
  {
    id: 3,
    date: '2026-04-15',
    photos: [{ id: 'demo-3a', url: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=800&auto=format&fit=crop', useInTimelapse: true }],
    glowScore: 8,
    tags: ['Glowy', 'Puffy'],
    water: 72,
    routines: { AM: ['Cleanser', 'Niacinamide', 'SPF 50'], PM: ['Oil Cleanser', 'Peptide Serum', 'Moisturizer'] },
    supplements: [{ name: 'Zinc', dose: '15mg' }, { name: 'Probiotic', dose: '1 capsule' }],
    treatments: [{ type: 'Red Light Therapy', area: 'Full Face', date: '2026-04-15', notes: '15 min session' }],
    makeup: { wore: false, products: [], doubleCleansed: false, notes: '' },
    cycle: { periodDay: true, flow: 'medium', symptoms: ['bloating'] },
    notes: 'Slight morning puffiness but overall skin looked luminous after RLT.'
  },
  {
    id: 7,
    date: '2026-04-14',
    photos: [{ id: 'demo-7a', url: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?q=80&w=800&auto=format&fit=crop', useInTimelapse: true }],
    glowScore: 4,
    tags: ['Breakout', 'Inflamed'],
    water: 40,
    routines: { AM: ['Cleanser', 'SPF 50'], PM: ['Oil Cleanser', 'AHA Exfoliant', 'Moisturizer'] },
    supplements: [],
    treatments: [],
    makeup: { wore: true, products: ['foundation', 'concealer'], doubleCleansed: false, notes: 'Had to cover a breakout.' },
    cycle: { periodDay: true, flow: 'heavy', symptoms: ['cramps', 'bloating'] },
    notes: 'Tried a new AHA exfoliant — skin did NOT agree. Red and irritated.'
  },
  {
    id: 8,
    date: '2026-04-11',
    photos: [{ id: 'demo-8a', url: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=800&auto=format&fit=crop', useInTimelapse: true }],
    glowScore: 5,
    tags: ['Dry', 'Breakout'],
    water: 48,
    routines: { AM: ['Cleanser', 'SPF 50'], PM: ['Oil Cleanser', 'AHA Exfoliant', 'Moisturizer'] },
    supplements: [],
    treatments: [],
    makeup: { wore: false, products: [], doubleCleansed: false, notes: '' },
    cycle: { periodDay: false, flow: null, symptoms: [] },
    notes: 'Skin still reacting to the AHA. Stopping it after today.'
  },
  {
    id: 4,
    date: '2026-04-10',
    photos: [{ id: 'demo-4a', url: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?q=80&w=800&auto=format&fit=crop', useInTimelapse: true }],
    glowScore: 7,
    tags: ['Smooth', 'Even tone'],
    water: 64,
    routines: { AM: ['Cleanser', 'Vitamin C Serum', 'SPF 50'], PM: ['Oil Cleanser', 'Retinol', 'Moisturizer'] },
    supplements: [{ name: 'Prenatal', dose: '1 tablet' }, { name: 'Collagen', dose: '10g' }],
    treatments: [{ type: 'Hydrafacial', area: 'Full Face', date: '2026-04-10', notes: 'Monthly treatment' }],
    makeup: { wore: false, products: [], doubleCleansed: false, notes: '' },
    cycle: { periodDay: false, flow: null, symptoms: [] },
    notes: 'Post-Hydrafacial glow! Skin feels hydrated and plump.'
  }
];

export const SKIN_TAGS = ['Glowy', 'Breakout', 'Dry', 'Puffy', 'Smooth', 'Acne', 'Even tone', 'Inflamed'];
export const SUPPLEMENT_PRESETS = ['Prenatal', 'Probiotic', 'Collagen', 'Zinc', 'Vitamin C', 'Omega-3', 'Biotin', 'Magnesium'];
export const TREATMENT_TYPES = ['Botox', 'Filler', 'Microneedling', 'Hydrafacial', 'Red Light Therapy', 'Chemical Peel', 'Laser', 'Facial', 'Dermaplaning'];
export const PRODUCT_CATEGORIES = ['Cleanser', 'Toner', 'Serum', 'Moisturizer', 'SPF', 'Eye Cream', 'Mask', 'Oil', 'Exfoliant', 'Retinol'];
export const BODY_AREAS = ['Full Face', 'Forehead', 'Cheeks', 'Jaw', 'Lips', 'Under Eyes', 'Neck', 'Décolletage'];
